<cap-content-header [disableBreadcrumb]="true">
  <cap-title>
    {{ "eigentuemerAdressliste.eigentuemerAdressliste" | translate }}
  </cap-title>
</cap-content-header>
<form (ngSubmit)="onSubmit()" [meta]="" #form="ngForm" column-classes="col-md-4,col-md-8">
  <div class="container mt-4">
    <div class="row">
      <cap-form-row column-classes="col-md-3,col-md-9">
        <cap-form-control invalidKey="EingabeMussValideNummerSeinBeispiel" labelKey="eigentuemerAdressliste.egridList">
          <textarea
            [(ngModel)]="egridListText"
            name="Egrid"
            placeholder="CH878977777700,CH747777897701,CH818977557702"
            rows="8"
            type="text"></textarea>
        </cap-form-control>
      </cap-form-row>
    </div>
  </div>
  <div class="row mt-4">
    <span class="fas fa-info-circle fa-2x fa-fw m-lg-2"></span>
    <div class="col-md-8">
      <div class="d-flex flex-column">
        <ul>
          <li>{{ "eigentuemerAdressliste.infoKommaTrennung" | translate }}</li>
          <li>{{ "eigentuemerAdressliste.infoEigentuemerAdressliste" | translate }}</li>
          <li>{{ "eigentuemerAdressliste.infoMizen" | translate }}</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">
        {{ "Zurücksetzen" | translate }}
      </button>
      <button [disabled]="!form.form.valid || !egridListText" class="btn btn-primary btn-actionpane" type="submit">
        {{ "eigentuemerAdressliste.listeErstellen" | translate }}
      </button>
    </div>
  </div>
</form>
